import cx from 'classnames';
import { DatePicker, Label } from 'llui';
import moment from 'moment';
import "./DateLimitEditor.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const format = 'DD/MM/YYYY';
export default function DateLimitEditor(_ref) {
  let {
    className,
    defaultLimit = null,
    label,
    limit = null,
    onChange,
    schema
  } = _ref;
  const placeholder = defaultLimit !== null ? moment(defaultLimit).format(format) : 'Unlimited';
  return /*#__PURE__*/_jsxs("div", {
    className: cx('DateLimitEditor', className),
    "data-sentry-component": "DateLimitEditor",
    "data-sentry-source-file": "DateLimitEditor.tsx",
    children: [/*#__PURE__*/_jsx(Label, {
      "data-sentry-element": "Label",
      "data-sentry-source-file": "DateLimitEditor.tsx",
      "data-sentry-element": "Label",
      children: label
    }), schema.customizable ? /*#__PURE__*/_jsx(DatePicker, {
      dateFormat: format,
      isClearable: true,
      onChange: value => onChange(value && value.toDate()),
      placeholderText: placeholder,
      selected: limit && moment(limit),
      showMonthDropdown: true,
      showYearDropdown: true
    }) : limit !== null ? /*#__PURE__*/_jsx("span", {
      className: "LimitEditor__value",
      children: moment(limit).format('DD/MM/YYYY')
    }) : /*#__PURE__*/_jsx("span", {
      className: "LimitEditor__value",
      children: placeholder
    })]
  });
}